import React from "react";
import { useRef } from "react";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Col,
  Row,
  Pagination,
  Checkbox,
  Spin,
  Tooltip as AntTooltip,
  Popover
} from "antd";
//import FormField from "../../components/formField";
import "./dpoMyChecklist.css";
import { Collapse, Empty, Button } from "antd";

//import icons
import { ReactComponent as ConfirmIcon } from "../../assets/waiting-for-approval.svg";
import { ReactComponent as Bin } from "../../assets/bin.svg";
import { ReactComponent as SubmitIcon2 } from "../../assets/submit2.svg";
import { ReactComponent as SubmitIcon } from "../../assets/submit.svg";
import { ReactComponent as Dots } from "../../assets/threeDots.svg";
import { ReactComponent as InfoIcon } from "../../assets/info.svg";
import { ReactComponent as Arrow } from "../../assets/vector.svg";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { isEmpty, set } from "lodash";
import { isString } from "lodash";
import { Upload } from "../../components";
import { DatePicker, Form, Input, Select, Space, Divider, Modal } from "antd";
import TextArea from "antd/es/input/TextArea";
import ColoredBulletLink from "../../components/shared/ColoredBulletLink";
import { PlusOutlined } from "@ant-design/icons";

import {
  assignInternalUser,
  updateInternalObligation,
  deleteInternalObligation
} from "../../store/internalObligations/actions";
// import { sendEmail } from "../../store/email/actions";
import { updateOrganizationInternalCategories } from "../../store/organizations/actions";

import { renderOptions } from "../../util/basicRenders";
// import { actionChangeMessage, assignToUserMessage } from "../../util/emailTemplates";

import MessagesList from "../dpo-internal/messagesList/MessagesList";
import { createMessage } from "../../store/obligations/actions";
import { useNavigate } from "react-router-dom";
import { setVariable } from "../../store/forms/actions";

const AddObligations = ({
  addObligations,
  setAddObligations,
  myTask,
  usersData,
  handleChangeAddObl,
  handleClearMessage,
  setChecked = () => {},
  panelStyle,
  displayedItems,
  currentPage,
  added,
  setAdded,
  setCurrentPage,
  organization,
  selectedInternalObligations = [],
  setSelectedInternalObligations = () => {},
  scrolled,
  setScrolled
}) => {
  const dispatchito = useDispatch();
  const { Panel } = Collapse;
  const dateFormat = "DD MMM YYYY";
  dayjs.extend(customParseFormat);
  const { Option } = Select;

  //create the login link
  const loginLink = `http://${process.env.REACT_APP_FILE_HOST}/regcom/login`;

  const user = useSelector(state => state.user);
  const navigate = useNavigate();
  const originalObligations = useSelector(
    state => state.internalObligations.internalObligations ?? []
  );
  const organizations = useSelector(state => state.organizations.organizations);
  const mainOptions = useSelector(
    state => state.organizations.organizationIdCategories ?? []
  );
  const navigateId = useSelector(state => state.internalObligations.navigateId);
  const [options, setOptions] = useState(mainOptions);

  useEffect(() => {
    setOptions(mainOptions);
  }, [mainOptions]);

  const documents = useSelector(state => state.documents?.internalObligations);
  const configurations = useSelector(state => state.forms.appConfig.pageList);
  const messages = useSelector(state => state.obligations.messages);
  const activeCompany =
    organizations?.find(item => item._id === organization) ?? {};
  const [selectedObligation, setSelectedObligation] = useState({});
  const [checkPage, setCheckPage] = useState(true);
  const [activeKey, setActiveKey] = useState("");
  const [elementId, setElementId] = useState("");
  const [check, setCheck] = useState(true);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [searchValue, setSearchValue] = useState("");

  console.debug("messages:", messages);
  const getUserName = id => {
    if (id !== "0") {
      const userId = originalObligations.find(item => item._id === id)?.user_id;
      const theUser = usersData.find(u => u._id === userId);
      return `${theUser?.firstName} ${theUser?.lastName}`;
    } else return "-";
  };

  const handleDelete = async obligation => {
    dispatchito(deleteInternalObligation(obligation, organization, user));
  };
  const { confirm } = Modal;
  const deleteConfirm = item => {
    confirm({
      title: "Delete Confirmation",
      icon: <ConfirmIcon />,
      content: `Are you sure you want to delete this obligation?`,
      okText: "Confirm",
      cancelText: "Close",
      onOk() {
        handleDelete(item);
      },
      onCancel() {}
    });
  };

  const content = item => (
    <div id="obligations-more-actions-list">
      {Object.values(
        Object.fromEntries(
          Object.entries(configurations)?.filter(
            ([key, values]) => key === user.role && values.includes("audit")
          )
        )
      ).length !== 0 && (
        <a
          id="obl-history-button"
          onClick={() => {
            dispatchito(
              setVariable({ key: "historySearch", value: item?.code })
            );
            navigate(`/audit`);
          }}
        >
          <span style={{ marginLeft: "-10.625rem" }}>History</span>
        </a>
      )}
      {user.role.includes("Assessor") && (
        <a id="obl-delete-button" onClick={() => deleteConfirm(item)}>
          <span style={{ marginLeft: "-10.625rem" }}>Delete</span>
        </a>
      )}
    </div>
  );

  const selectObligation = async value => {
    setSelectedObligation(value);
  };

  //handlers
  const handlePageChange = page => {
    setCurrentPage(page);
    setChecked(false);
    setSelectedInternalObligations([]);
    setLoadingSubmit(true);
    setActiveKey("");
  };

  useEffect(() => {
    setLoadingSubmit(false);
  }, [currentPage]);

  useEffect(() => {
    if (navigateId) {
      setLoadingSubmit(true);
    }
  }, []);

  useEffect(() => {
    if (navigateId && !isEmpty(addObligations)) {
      const startPage = Math.ceil(
        (addObligations?.findIndex(ob => ob._id === navigateId) + 1) / 5
      );
      const activeNum =
        Math.ceil(
          (addObligations?.findIndex(ob => ob._id === navigateId) + 1) / 5
        ) *
          5 -
        addObligations?.findIndex(ob => ob._id === navigateId);

      if (startPage !== 0 && checkPage) {
        setCheckPage(false);
        setCurrentPage(startPage);
        if (activeNum === 1) {
          setActiveKey(4);
        } else if (activeNum === 2) {
          setActiveKey(3);
        } else if (activeNum === 3) {
          setActiveKey(2);
        } else if (activeNum === 4) {
          setActiveKey(1);
        } else {
          setActiveKey(0);
        }
      }
    } else {
      setScrolled(true);
    }
  }, [navigateId, addObligations]);

  useEffect(() => {
    if (!checkPage) {
      setLoadingSubmit(false);
    }
  }, [checkPage]);

  useEffect(() => {
    const targetElement = document.getElementById(navigateId);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
      dispatchito({
        type: "CLEAR_NAVIGATE_INTERNAL_ID"
      });
      setScrolled(true);
    }
  }, [navigateId, currentPage, loadingSubmit]);

  const onCheckboxChange = (e, item, index) => {
    if (selectedInternalObligations?.includes(item)) {
      const updatedSelectedObligations = selectedInternalObligations?.filter(
        selectedItem => selectedItem !== item
      );
      setSelectedInternalObligations(updatedSelectedObligations);
    } else {
      setSelectedInternalObligations([...selectedInternalObligations, item]);
    }
  };

  const handleSubmit = async ({ obligation, id }) => {
    setLoadingSubmit(true);
    const formData = new FormData();
    formData.append("description", obligation.description);
    formData.append("dueDate", obligation.dueDate ? obligation.dueDate : "");
    formData.append("assessment", obligation.assessment);
    formData.append("mainCategory", obligation.mainCategory);
    formData.append("comments", obligation.comments);
    formData.append("user_id", obligation.user_id);
    formData.append("action", obligation.action);

    // if (obligation.files) {
    //   Object.values(obligation.files).forEach((file, index) => {
    //     formData.append("files", file);
    //   });
    // } //we dont keep files inside obligation anymore

    dispatchito(
      updateInternalObligation({
        obligation,
        formData,
        user,
        callback: check => {
          setElementId(obligation._id);
          setCheck(check);
        },
        emailCallback: recipients => {
          // if (isEmpty(recipients) || !Array.isArray(recipients)) return;
          // for (const recipient of recipients) {
          //   dispatchito(
          //     sendEmail({
          //       user,
          //       to: [recipient?.email],
          //       cc: [],
          //       subject: `${
          //         recipient?.company ? recipient.company + " - " : ""
          //       }Action Change`,
          //       message: actionChangeMessage(obligation, recipient),
          //       isHtmlMessage: true
          //       // message: 'HELLO text',
          //       // isHtmlMessage: false,
          //     })
          //   );
          // }
        }
      })
    );
  };

  console.debug("displayedItems:", displayedItems);
  const unassignUser = ({ item }) => {
    dispatchito(
      assignInternalUser({
        newItem: {
          _id: item._id,
          user_id: "0"
        },
        user,
        organizationId: organization,
        callback: check => {
          setElementId(item._id);
          user.role === "assignedUser" ? setCheck(false) : setCheck(check);
        }
      })
    );
  };

  const handleAssign = async ({ item }) => {
    const newItem = { ...item };
    newItem.isAssigned = item.user_id !== "0";
    dispatchito(
      assignInternalUser({
        newItem,
        user,
        organizationId: organization,
        callback: check => {
          setElementId(newItem._id);
          user.role === "assignedUser" ? setCheck(false) : setCheck(check);
          // const userAssigned = usersData.find(
          //   item => item._id === newItem.user_id
          // );
          // if (item.user_id !== "0")
          //   dispatchito(
          //     sendEmail({
          //       user,
          //       to: [userAssigned.email],
          //       cc: [],
          //       subject: 'Assigned Internal Obligation',
          //       message: assignToUserMessage(newItem, user),
          //       isHtmlMessage: true,
          //       // message: 'HELLO text',
          //       // isHtmlMessage: false,
          //     }));
        }
      })
    );
  };

  const handleEnterMessage = (id, message) => {
    // console.log("id:",id);
    // console.log("id:",message);
    // setLoadingSubmit(true);
    dispatchito(
      createMessage(user, id, message, organization, check => {
        setElementId(id);
        setCheck(check);
        // setLoadingSubmit(false);
      })
    );
    handleClearMessage({
      event: "",
      id: id,
      key: "messages",
      type: "text"
    });
    // dispatchito(getAllMessages(user, organization));
  };

  const [option, setOption] = useState("");

  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    if (searchTerm.length > 0) {
      const filtered = !isEmpty(mainOptions)
        ? mainOptions.filter(option =>
            option?.toLowerCase().includes(searchTerm.toLowerCase())
          )
        : [];

      setOptions(filtered);
    } else {
      setOptions(mainOptions);
    }
  }, [searchTerm]);

  const onOptionChange = event => {
    setSearchTerm(event.target.value);
    setOption(event.target.value);
  };

  const clearOption = () => {
    setOption("");
  };

  const addOption = () => {
    if (option.trim() && !mainOptions.includes(option.trim())) {
      dispatchito(
        updateOrganizationInternalCategories(
          user,
          activeCompany?._id,
          option.trim()
        )
      );
    }
    setOptions(mainOptions);
  };

  const [currentPageSetted, setCurrentPageSetted] = useState(false);
  useEffect(() => {
    if (elementId && check) {
      // console.debug("elementId:",elementId);
      setCurrentPage(
        Math.ceil(
          (addObligations?.findIndex(ob => ob._id === elementId) + 1) / 5
        )
      );

      const activeNum =
        Math.ceil(
          (addObligations?.findIndex(ob => ob._id === elementId) + 1) / 5
        ) *
          5 -
        addObligations?.findIndex(ob => ob._id === elementId);

      if (activeNum === 1) {
        setActiveKey(4);
      } else if (activeNum === 2) {
        setActiveKey(3);
      } else if (activeNum === 3) {
        setActiveKey(2);
      } else if (activeNum === 4) {
        setActiveKey(1);
      } else {
        setActiveKey(0);
      }

      setCheck(false);
      setCurrentPageSetted(true);
      setLoadingSubmit(false);
    }
  }, [check, elementId]);

  useEffect(() => {
    console.debug("added:", added);
    if (added) {
      console.debug("navigateId:", navigateId);
      if (addObligations.length > 0) {
        setCurrentPage(
          Math.ceil(
            (addObligations.findIndex(ob => ob._id === navigateId) + 1) / 5
          )
        );
        setElementId(navigateId);
        setCurrentPageSetted(true);

        const activeNum =
          Math.ceil(
            (addObligations.findIndex(ob => ob._id === navigateId) + 1) / 5
          ) *
            5 -
          addObligations.findIndex(ob => ob._id === navigateId);

        if (activeNum === 1) {
          setActiveKey(4);
        } else if (activeNum === 2) {
          setActiveKey(3);
        } else if (activeNum === 3) {
          setActiveKey(2);
        } else if (activeNum === 4) {
          setActiveKey(1);
        } else {
          setActiveKey(0);
        }
      }
      setAdded(false);
      dispatchito({
        type: "CLEAR_NAVIGATE_INTERNAL_ID"
      });
    }
  }, [added]);

  // useEffect(() => {
  //   console.debug("currentPageSetted:",currentPageSetted);
  //   if (currentPageSetted && document.getElementById(elementId)) {
  //     if (elementId) {
  //       document
  //         .getElementById(elementId)
  //         .scrollIntoView({ behavior: "smooth" });
  //     }
  //     setCurrentPageSetted(false);
  //   }
  //   else if(currentPageSetted){
  //     setCurrentPageSetted(false);
  //   }
  // }, [currentPageSetted,elementId]);

  useEffect(() => {
    if (currentPageSetted) {
      document
        .getElementById(elementId)
        ?.scrollIntoView({ behavior: "smooth" });
      setCurrentPageSetted(false);
    }
  }, [currentPageSetted]);

  return loadingSubmit || added ? (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginLeft: "755px",
        marginTop: "50px"
      }}
    >
      <Spin size="large" />
    </div>
  ) : (
    <div className="my-internal-row" id="add-obligations-my-internal-row">
      <Collapse
        className="my-check-list additional"
        id="add-obligations-my-check-list-additional"
        defaultActiveKey={activeKey}
        accordion
        expandIconPosition="end"
        expandIcon={({ isActive }) =>
          isActive ? (
            <Button
              id="seeLess-button"
              className="icon-center  expand-icon-obligations"
              style={{
                fontSize: "0.875rem",
                position: "absolute",
                bottom: "5.625rem",
                left: "-0.5rem",
                zIndex: "10"
              }}
              type="default"
              icon={
                <span
                  id="greater"
                  style={{
                    transform: "rotate(0.75turn)",
                    // display: "inline-flex",
                    marginLeft: "0.2rem",
                    marginTop: "-0.1rem",
                    width: "100%"
                  }}
                >
                  <SubmitIcon />
                </span>
              }
            ></Button>
          ) : (
            <Button
              className="icon-center  expand-icon-obligations"
              id="main-obligations-icon-center-see-more-button-expand-icon-obligations"
              style={{
                fontSize: "0.875rem",
                position: "absolute",
                bottom: "5.625rem",
                left: "-0.5rem",
                width: "6.188rem",
                zIndex: "10",
                border: "none"
              }}
              type="default"
              icon={
                <span
                  id="greater"
                  style={{
                    transform: "rotate(0.25turn)",
                    // display: "inline-flex",
                    marginLeft: "-0.05rem",
                    marginTop: "0.2rem",
                    width: "100%"
                  }}
                >
                  <SubmitIcon />
                </span>
              }
            ></Button>
          )
        }
      >
        {!isEmpty(displayedItems) ? (
          displayedItems.map((item, index) => (
            <Panel
              id={`${item._id}`}
              style={panelStyle}
              collapsible="icon"
              header={
                <Form
                  wrapperCol={{
                    span: 24
                  }}
                  className="row-height"
                  id="add-obligations-form"
                >
                  <Row
                    className="row-height"
                    id="add-obligations-rows"
                    gutter={{ xs: 8, sm: 12, md: 24, lg: 22 }}
                  >
                    {/* <Col span={2}>
                      <Form.Item id="ad_id">
                        <TextArea
                          id={`ad_id_${index}`}
                          className="no-action"
                          bordered={false}
                          autoSize={{ minRows: 1, maxRows: 3 }}
                          value={itemsPerPage * (currentPage - 1) + index + 1}
                        ></TextArea>
                      </Form.Item>
                    </Col> */}
                    {user.role !== "assignedUser" && (
                      <Form.Item id="ob_int_checkbox">
                        <Checkbox
                          checked={selectedInternalObligations.includes(item)}
                          style={{
                            position: "absolute",
                            left: "-2.3rem",
                            top: "5.313rem"
                          }}
                          onChange={e => onCheckboxChange(e, item, index)}
                          disabled={
                            user.role === "corporateComplianceObserver" ||
                            user.role === "groupComplianceObserver"
                          }
                        />
                      </Form.Item>
                    )}

                    <Col
                      // span={3}
                      className="internal-action-col"
                      id="add-obligations-internal-id-col"
                    >
                      <Form.Item id="ad_id">
                        <TextArea
                          id={`ad_id_${index}`}
                          bordered={false}
                          disabled
                          value={item.code || "-"}
                          autoSize={{ minRows: 1, maxRows: 4 }}
                          style={{
                            padding: "0.313rem 0",
                            fontSize: "0.875rem",
                            marginLeft: "35px"
                          }}
                        ></TextArea>
                      </Form.Item>
                    </Col>

                    <Col
                      // span={3}
                      className="internal-category-col"
                      id="add-obligations-internal-category-col"
                    >
                      <Form.Item id="ad_cat">
                        {myTask ? (
                          <TextArea
                            id={`ad_cat_${index}`}
                            bordered={false}
                            disabled
                            value={item.mainCategory}
                            autoSize={{ minRows: 1, maxRows: 4 }}
                            style={{
                              padding: "0.313rem 0",
                              fontSize: "0.875rem"
                            }}
                          ></TextArea>
                        ) : (
                          <Select
                            virtual={false}
                            // dropdownStyle={{maxHeight:"15.625rem"}}
                            style={{ textAlign: "left" }}
                            id={`ob_category_${index}`}
                            disabled={
                              myTask ||
                              user.role === "corporateComplianceObserver" ||
                              user.role === "groupComplianceObserver"
                            }
                            onChange={value =>
                              handleChangeAddObl({
                                event: value,
                                id: item._id,
                                key: "mainCategory",
                                type: "select"
                              })
                            }
                            value={item.mainCategory}
                            dropdownRender={menu => (
                              <div>
                                <div>{menu}</div>
                                <div
                                  style={{
                                    position: "sticky",
                                    bottom: "0",
                                    backgroundColor: "#FAFAFA"
                                  }}
                                >
                                  <Divider style={{ margin: "8px 0" }} />
                                  <Space style={{ backgroundColor: "#FAFAFA" }}>
                                    <Input
                                      placeholder="Please enter new item"
                                      value={option}
                                      onChange={onOptionChange}
                                    />
                                  </Space>
                                  <Space
                                    style={{
                                      backgroundColor: "#FAFAFA",
                                      marginTop: "8px"
                                    }}
                                  >
                                    <Button
                                      type="text"
                                      icon={<PlusOutlined />}
                                      onClick={() => {
                                        addOption();
                                        handleChangeAddObl({
                                          event: option.trim(),
                                          id: item._id,
                                          key: "mainCategory",
                                          type: "select"
                                        });
                                        clearOption();
                                      }}
                                    >
                                      <b>&nbsp;Add item</b>
                                    </Button>
                                  </Space>
                                </div>
                              </div>
                            )}
                            // options={categoryOptions}
                            options={options.map(item => ({
                              label: item,
                              value: item
                            }))}
                          ></Select>
                        )}
                      </Form.Item>
                    </Col>

                    <Col
                      // span={4}
                      className="internal-obligation-col"
                      id="add-obligations-internal-obligation-col"
                    >
                      {myTask ? (
                        <AntTooltip
                          title={() => (
                            <div style={{ whiteSpace: "pre-wrap" }}>
                              {item?.description}
                            </div>
                          )}
                          arrow={false}
                          overlayClassName="description-tooltip"
                          mouseEnterDelay={0.5}
                          placement="bottomLeft"
                        >
                          <Form.Item id="ob_desc">
                            <TextArea
                              id={`ob_desc_${index}`}
                              className="myinternal-desc"
                              disabled={true}
                              bordered={false}
                              value={item.description}
                              autoSize={{ minRows: 1, maxRows: 6 }}
                            ></TextArea>
                          </Form.Item>
                        </AntTooltip>
                      ) : (
                        <Form.Item id="ad_desc">
                          <TextArea
                            id={`ad_desc_${index}`}
                            disabled={
                              // myTask ||
                              user.role === "corporateComplianceObserver" ||
                              user.role === "groupComplianceObserver"
                            }
                            // bordered={!myTask}
                            onChange={value =>
                              handleChangeAddObl({
                                event: value,
                                id: item._id,
                                key: "description",
                                type: "text"
                              })
                            }
                            // span={4}
                            value={item.description}
                            autoSize={{ minRows: 5, maxRows: 6 }}
                          ></TextArea>
                          {item?.info && (
                            <AntTooltip
                              title={() => (
                                <div style={{ whiteSpace: "pre-wrap" }}>
                                  {item?.info}
                                </div>
                              )}
                              arrow={false}
                              overlayClassName="description-tooltip"
                              mouseEnterDelay={0.5}
                              placement="bottomLeft"
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center"
                                }}
                              >
                                <InfoIcon
                                  style={{ height: "13px", width: "13px" }}
                                />
                                <text
                                  style={{
                                    fontSize: "11px",
                                    color: "#725798",
                                    marginLeft: "5px"
                                  }}
                                >
                                  Obligation Info
                                </text>
                              </div>
                            </AntTooltip>
                          )}
                        </Form.Item>
                      )}
                    </Col>

                    <Col
                      // span={3}
                      className="internal-action-col"
                      id="add-obligations-internal-action-col"
                    >
                      <Form.Item id="ob_action">
                        <Select
                          virtual={false}
                          style={{ textAlign: "left" }}
                          id={`ob_action_${index}`}
                          className="action-select"
                          disabled={
                            // myTask ||
                            user.role === "corporateComplianceObserver" ||
                            user.role === "groupComplianceObserver" ||
                            (myTask && item?.assessment === "Compliant")
                          }
                          onChange={value =>
                            handleChangeAddObl({
                              event: value,
                              id: item._id,
                              key: "action",
                              type: "select"
                            })
                          }
                          value={item.action}
                        >
                          <Select.Option value="Pending">Pending</Select.Option>
                          <Select.Option value="Completed">
                            Completed
                          </Select.Option>
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col
                      // span={3}
                      className="internal-assessment-col"
                      id="add-obligations-internal-assessment-col"
                    >
                      <Form.Item id="ad_as">
                        <Select
                          virtual={false}
                          style={{ textAlign: "left" }}
                          id={`ad_as_${index}`}
                          className="assessment-select"
                          popupClassName="assessment-dropdown"
                          disabled={
                            // myTask ||
                            user.role === "corporateComplianceObserver" ||
                            user.role === "groupComplianceObserver" ||
                            user.role === "assignedUser"
                          }
                          onChange={value =>
                            handleChangeAddObl({
                              event: value,
                              id: item._id,
                              key: "assessment",
                              type: "select"
                            })
                          }
                          value={item.assessment}
                        >
                          <Select.Option value="Partially">
                            <span className="assessment-tag-option partially-compliant">
                              Partially Compliant
                            </span>
                          </Select.Option>
                          <Select.Option value="Compliant">
                            <span className="assessment-tag-option compliant">
                              Compliant
                            </span>
                          </Select.Option>
                          <Select.Option value="Non-Compliant">
                            <span className="assessment-tag-option non-compliant">
                              Non Compliant
                            </span>
                          </Select.Option>
                          <Select.Option value="na">
                            <span className="assessment-tag-option na">
                              N/A
                            </span>
                          </Select.Option>
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col
                      // span={3}
                      className="internal-due-col"
                      id="add-obligations-internal-due-col"
                    >
                      <Form.Item id="ad_due">
                        <DatePicker
                          id={`ad_due_${index}`}
                          disabled={
                            // myTask ||
                            user.role === "corporateComplianceObserver" ||
                            user.role === "groupComplianceObserver"
                          }
                          placeholder={
                            user.role === "corporateComplianceObserver" ||
                            user.role === "groupComplianceObserver" ||
                            myTask
                              ? "-"
                              : "Select Date"
                          }
                          bordered={!myTask}
                          className={myTask ? "no-action" : ""}
                          format={dateFormat}
                          value={
                            isString(item.dueDate)
                              ? dayjs(item.dueDate)
                              : item.dueDate
                          }
                          onChange={(date, dateString) =>
                            handleChangeAddObl({
                              event: date,
                              id: item._id,
                              key: "dueDate",
                              type: "date"
                            })
                          }
                          allowClear={false}
                        ></DatePicker>
                      </Form.Item>
                    </Col>
                    <Col
                      // span={2}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        paddingLeft: 0
                      }}
                      className="internal-submit-col"
                    >
                      {/* <div
                        id={`ob_save_btn_${index}`}
                        className="savebutton"
                        onClick={() =>
                          handleSubmit({ obligation: item, id: item._id })
                        }
                      >
                        > Submit
                      </div> */}
                      {user.role !== "corporateComplianceObserver" &&
                        user.role !== "groupComplianceObserver" && (
                          <>
                            <Button
                              id={`ob_save_btn_${index}`}
                              type="primary"
                              className="checklist-submit"
                              // style={{ marginBottom: "0.138rem" }}
                              onClick={() =>
                                handleSubmit({ obligation: item, id: item._id })
                              }
                            >
                              Submit
                              <span
                                id="greater"
                                style={{
                                  display: "inline-flex",
                                  marginLeft: "0.4rem"
                                }}
                              >
                                <SubmitIcon2 />
                              </span>
                            </Button>
                            <Popover
                              placement="bottomRight"
                              overlayClassName="custom-popover"
                              content={content(item)}
                              arrow={false}
                              trigger="click"
                            >
                              <a
                                className="three-dots"
                                style={{
                                  position: "absolute",
                                  left: "5.5rem",
                                  bottom: "4.99rem",
                                  border: "none"
                                }}
                                onClick={() => selectObligation(item)}
                              >
                                <Dots />
                              </a>
                            </Popover>
                          </>
                        )}
                    </Col>
                  </Row>
                </Form>
              }
              key={index}
            >
              {/* expanded pane titles */}
              <Row
                className="obligations-list-second-row-headers"
                id="add-obligations-row"
                gutter={{ xs: 8, sm: 12, md: 24, lg: 22 }}
              >
                <Col
                  // span={4}
                  className="internal-owner-col"
                  style={{ textAlign: "left" }}
                >
                  <span
                    className="title-style"
                    id="ob-page-title-style-6"
                    style={{ paddingLeft: "0.125rem", marginLeft: "-0.125rem" }}
                  >
                    Owner
                  </span>
                </Col>
                <Col
                  // span={2}
                  className="internal-comments-col"
                  style={{ textAlign: "left", marginLeft: "0.625rem" }}
                >
                  <span className="title-style">Comments</span>
                </Col>

                <Col
                  className="internal-remindme-col"
                  id="add-obligations-internal-remindme-col"
                  // span={myTask ? 6 : 6}
                >
                  <span
                    className="title-style"
                    style={{ paddingLeft: "1.375rem" }}
                  >
                    Add Reminder
                  </span>
                </Col>
                <Col
                  // span={2}
                  className="internal-docs-col"
                  style={{ textAlign: "left", marginLeft: "0.5rem" }}
                >
                  <span className="title-style">Supporting Documents</span>
                </Col>
              </Row>
              <Form
                wrapperCol={{
                  span: 24
                }}
                layout="vertical"
                className="row-height"
                id="add-obligations-row-height"
              >
                <Row
                  className="row-height"
                  id="add-obligations-row-height-2"
                  gutter={{ xs: 8, sm: 12, md: 24, lg: 22 }}
                  style={{paddingBottom: '20px'}}
                >
                  {/* <Col
                    // span={4}
                    className="internal-comments-col"
                    id="add-obligations-internal-comments-col"
                  >
                    <Form.Item id="ad_com">
                      <TextArea
                        id={`ad_com_${index}`}
                        // className="mb-1"
                        disabled={
                          user.role === "corporateComplianceObserver" ||
                          user.role === "groupComplianceObserver"
                        }
                        onChange={value =>
                          handleChangeAddObl({
                            event: value,
                            id: item._id,
                            key: "comments",
                            type: "text"
                          })
                        }
                        value={item.comments}
                        autoSize={{ minRows: 5, maxRows: 5 }}
                      ></TextArea>
                    </Form.Item>
                  </Col> */}

                  <Col
                    className="internal-owner-col"
                    id="add-oblogations-internal-owner-col-2"
                    // span={4}
                  >
                    <Form.Item className="" id="ad_own">
                      <div
                        style={
                          item?.isAssigned
                            ? { marginTop: "-5.313rem" }
                            : { marginTop: "-6.313rem" }
                        }
                        className={
                          user.role === "assignedUser"
                            ? "owner-tag-obl"
                            : "owner-tag-obl mt-05"
                        }
                      >
                        {item?.isAssigned ? (
                          <ColoredBulletLink
                            text={
                              usersData && item?._id && getUserName(item._id)
                            }
                            // obligationID={item._id}
                            unassign={() => unassignUser({ item })}
                            allowClear={[
                              "assignedUser",
                              "corporateComplianceAssessor",
                              "groupComplianceAssessor"
                            ].includes(user.role)}
                          />
                        ) : (
                          <></>
                        )}
                      </div>
                      <Select
                        // dropdownStyle={{ maxHeight: "17em" }}
                        virtual={false}
                        style={{ textAlign: "left" }}
                        id={`ad_own_${index}`}
                        disabled={user.role.includes("Observer")}
                        className="assign-select"
                        showSearch
                        allowClear
                        filterOption={false}
                        onSearch={setSearchValue}
                        placeholder="Select..."
                        onChange={value =>
                          handleChangeAddObl({
                            event: value ?? "0",
                            id: item._id,
                            key: "user_id",
                            type: "select"
                          })
                        }
                        value={
                          usersData &&
                          !isEmpty(usersData) &&
                          Array.isArray(usersData) &&
                          usersData.length > 0
                            ? usersData
                                ?.filter(b => b._id === item.user_id)
                                .map(b => `${b.firstName} ${b.lastName}`)
                            : null
                        }
                      >
                        {renderOptions(searchValue, usersData)}
                      </Select>
                      <div
                        id={`assign_btn_${index}`}
                        className="assign-button assign-button-main"
                        onClick={() => handleAssign({ item })}
                        style={{
                          visibility:
                            user.role === "corporateComplianceObserver" ||
                            user.role === "groupComplianceObserver"
                              ? "hidden"
                              : "visible"
                        }}
                      >
                        {!item?.isAssigned ? "Assign" : "Reassign"}
                      </div>
                    </Form.Item>
                  </Col>

                  <Col
                    // span={9}
                    className="internal-comments-col"
                    id="add-obligations-internal-comments-col"
                    style={{marginLeft: '0.6rem'}}
                  >
                    <Form.Item
                      style={{ 
                        // marginTop: "-2.275rem" 
                      }}
                      className="mt-0"
                      id="ob_com"
                    >
                      <div className="listcontainer">
                        <MessagesList
                          messages={messages}
                          item_id={item._id}
                          user={user}
                        />
                      </div>
                      <Input
                        style={{
                          backgroundColor: "#FAFAFF",
                          // marginLeft: "10px",
                          // position: "absolute",
                          // left: "0px",
                          // top: "190px",
                          borderTopLeftRadius: 'unset',
                          borderTopRightRadius: 'unset',
                        }}
                        onChange={value =>
                          handleChangeAddObl({
                            event: value,
                            id: item._id,
                            key: "messages",
                            type: "text"
                          })
                        }
                        className="message-input"
                        value={item?.messages}
                        placeholder="Make a new comment.."
                        onPressEnter={() =>
                          item.messages &&
                          handleEnterMessage(item?._id, item?.messages)
                        }
                        suffix={
                          <Button
                            style={{
                              backgroundColor: "#CDCDCD",
                              width: "22px",
                              height: "22px",
                              borderRadius: "50%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              border: "none",
                              padding: "0",
                              cursor: "pointer"
                            }}
                            onClick={() =>
                              handleEnterMessage(item?._id, item?.messages)
                            }
                          >
                            <Arrow />
                          </Button>
                        }
                      />
                    </Form.Item>
                  </Col>

                  <Col
                    className="ml-1 internal-remindme-col"
                    id="add-obligations-ml-1-internal-remindme-col"
                    // span={4}
                  >
                    <Form.Item>
                      {/* <span>Frequency</span>
                      <Select id={`ad_freq_${index}`} className="mb-1"></Select> */}
                      {/* <span>Send me a notification</span> */}
                      <Row
                        gutter={{ xs: 8, sm: 12, md: 24, lg: 22 }}
                        style={{ paddingBottom: "2.188rem" }}
                      >
                        {" "}
                        {/**temporary style until frequency is put back */}
                        <div style={{ width: "30%", paddingRight: "5%" }}>
                          <Select
                            virtual={false}
                            style={{ textAlign: "left" }}
                            id={`ad_notif_num_${index}`}
                            disabled={
                              user.role === "corporateComplianceObserver" ||
                              user.role === "groupComplianceObserver"
                            }
                          >
                            <Option value="1">1</Option>
                            <Option value="10">10</Option>
                            <Option value="30">30</Option>
                          </Select>
                        </div>
                        <div style={{ width: "65%" }}>
                          <Select
                            virtual={false}
                            id={`ad_notif_metric_${index}`}
                            disabled={
                              user.role === "corporateComplianceObserver" ||
                              user.role === "groupComplianceObserver"
                            }
                          >
                            <Option value="days">Days Before Due Date</Option>
                            <Option value="months">
                              Months Before Due Date
                            </Option>
                          </Select>
                        </div>
                      </Row>
                    </Form.Item>
                  </Col>
                  <Col
                    // span={7}
                    className="internal-docs-col"
                    id="add-obligations-mt-2-internal-docs-col"
                    // style={{marginLeft:"2rem"}}
                  >
                    <Upload
                      disabled={
                        user.role === "corporateComplianceObserver" ||
                        user.role === "groupComplianceObserver"
                      }
                      multiple
                      item={{
                        fileCode: "addObl",
                        required: true,
                        fileAccepts: ".pdf",
                        fileLimit: 30,
                        files: documents?.[item._id],
                        multiple: true
                      }}
                      group={"internalObligations"}
                      accept={".pdf"}
                      // handleFiles={handleFileChange}
                      // id={item._id}
                      obligation_id={item._id}
                      obligations={addObligations}
                      organization={item.organization}
                      setAddObligations={setAddObligations}
                    />
                  </Col>
                </Row>
              </Form>
            </Panel>
          ))
        ) : (
          <Empty
            className="mt-12"
            id="add-obligations-empty-mt-12"
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={
              <>
                <span>No Data</span>
              </>
            }
          ></Empty>
        )}
      </Collapse>
      <Pagination
        showSizeChanger={false}
        id="add-obligations-pagination"
        current={currentPage}
        pageSize={5}
        total={addObligations && addObligations.length}
        onChange={handlePageChange}
      />
    </div>
  );
};

export default AddObligations;
